import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaComments, FaLanguage, FaSignOutAlt, FaHome, FaSearch, FaTachometerAlt, FaBars, FaTimes } from 'react-icons/fa';
import { useAuthContext } from '@asgardeo/auth-react';

const Navigation = () => {
  const location = useLocation();
  const { signOut } = useAuthContext();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleSignOut = () => {
    signOut();
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const navigationLinks = [
    {
      to: "/chatlogs",
      icon: <FaComments />,
      label: "Chat Logs",
      isActive: location.pathname === '/chatlogs'
    },
    {
      to: "/translatelogs",
      icon: <FaLanguage />,
      label: "Translation Logs",
      isActive: location.pathname === '/translatelogs' || location.pathname === '/translate'
    },
    {
      to: "/queryclassificationlogs",
      icon: <FaSearch />,
      label: "Query Classification",
      isActive: location.pathname === '/queryclassificationlogs'
    },
    {
      to: "/master-dashboard",
      icon: <FaTachometerAlt />,
      label: "Master Dashboard",
      isActive: location.pathname === '/master-dashboard'
    }
  ];

  return (
    <nav className="bg-pl_bg_light_3 border-b border-pl_border_light_1 shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo/Brand */}
          <div className="flex items-center">
            <Link
              to="/"
              className="text-xl font-bold text-pl_prim_color_1 hover:text-pl_prim_color_1 transition-colors"
              onClick={closeMobileMenu}
            >
              Log Viewer
            </Link>
          </div>

          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center space-x-4">
            {navigationLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                  link.isActive
                    ? 'bg-pl_prim_color_1 text-pl_bg_light_3'
                    : 'text-pl_txt_light_2 hover:text-pl_prim_color_1 hover:bg-pl_bg_light_5'
                }`}
              >
                {link.icon}
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop Sign Out Button */}
          <div className="hidden md:flex items-center">
            <button
              onClick={handleSignOut}
              className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-pl_txt_light_2 hover:text-pl_prim_color_1 hover:bg-pl_bg_light_5 rounded-lg transition-all"
            >
              <FaSignOutAlt />
              Sign Out
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMobileMenu}
              className="flex flex-col justify-center items-center w-8 h-8 p-1 text-pl_txt_light_2 hover:text-pl_prim_color_1 transition-colors"
              aria-label="Toggle mobile menu"
            >
              {/* Custom Animated Hamburger Icon */}
              <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ease-in-out transform ${
                isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''
              }`}></span>
              <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ease-in-out transform mt-1.5 ${
                isMobileMenuOpen ? 'opacity-0' : ''
              }`}></span>
              <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ease-in-out transform mt-1.5 ${
                isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
              }`}></span>
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-16 right-0 z-50">
            <div className="w-80 px-2 pt-2 pb-3 space-y-1 bg-pl_bg_light_4 border border-pl_border_light_1 rounded-lg shadow-lg mr-4 max-w-[calc(100vw-2rem)]">
              {/* Mobile Navigation Links */}
              {navigationLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`flex items-center gap-3 px-3 py-3 rounded-lg text-base font-medium transition-all ${
                    link.isActive
                      ? 'bg-pl_prim_color_1 text-pl_bg_light_3'
                      : 'text-pl_txt_light_2 hover:text-pl_prim_color_1 hover:bg-pl_bg_light_5'
                  }`}
                  onClick={closeMobileMenu}
                >
                  {link.icon}
                  {link.label}
                </Link>
              ))}
              
              {/* Mobile Sign Out Button */}
              <button
                onClick={handleSignOut}
                className="w-full flex items-center gap-3 px-3 py-3 text-base font-medium text-pl_txt_light_2 hover:text-pl_prim_color_1 hover:bg-pl_bg_light_5 rounded-lg transition-all"
              >
                <FaSignOutAlt />
                Sign Out
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation; 